import script from "./comHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./comHeader.vue?vue&type=script&setup=true&lang=js"

import "./comHeader.vue?vue&type=style&index=0&id=c37fff68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c37fff68"]])

export default __exports__